// Force Horizon header to stay in "drawer" mode on desktop
(function () {
  function forceDrawer() {
    const header = document.querySelector("#header-component");
    if (!header) return;

    // Only do this on desktop breakpoint used by Horizon
    if (window.matchMedia("(min-width: 750px)").matches) {
      if (header.getAttribute("data-menu-style") !== "drawer") {
        header.setAttribute("data-menu-style", "drawer");
      }
    }
  }

  // Run now
  forceDrawer();

  // Run on resize
  window.addEventListener("resize", forceDrawer);

  // Run if hydration / scripts flip it back
  const obs = new MutationObserver(forceDrawer);
  obs.observe(document.documentElement, { attributes: true, subtree: true });
})();